const ems = {
  ko: {
    key702: '블루배터리 방전(-)',
    key703: '수요예측',
    key704: '실제 수요',
    key705: '태양광 예측',
    key706: '태양광 실제 발전량',
    key707: '현재',
    key708: '시',
  },
  en: {
    key702: 'Battery Discharge (-)',
    key703: 'Demand Forecast',
    key704: 'Actual Demand',
    key705: 'Solar Power Forecast',
    key706: 'Actual Solar Generation',
    key707: 'Current',
    key708: 'Time',
  },
  vi: {
    key702: 'Xả pin Battery (-)',
    key703: 'Dự báo nhu cầu',
    key704: 'Nhu cầu thực tế',
    key705: 'Dự báo năng lượng mặt trời',
    key706: 'Sản lượng điện mặt trời thực tế',
    key707: 'Hiện tại',
    key708: 'Thời gian / Giờ',
  },
}

export default ems;